import { Pipe, PipeTransform } from '@angular/core';
import { numberSeparator } from '../../utils/number-separator';
import { round } from '../../utils/round';

@Pipe({ name: 'indianCurrency', standalone: false})
export class IndianCurrency implements PipeTransform {
  public transform(
    value: number | null | undefined,
    pointValue: number = 2
  ): string {
    value = !value ? 0 : value;
    if (!isNaN(value)) {
      const currencySymbol = '₹';
      return currencySymbol + numberSeparator(round(value, pointValue));
    }
    return '';
  }
}
